import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createIssuerConfig, viewIssuerConfig } from "../actions/issuerConfig.actions";
import ConfigurationForm from "./components/Form";

const IssuerConfigForm = ({ dispatch, config, issuerCode, emvProfileCodes, scpIssuers, persoFormatCodes, match, scpConfiguration, history }) => {
    const getSCPObject = (configkey, valueKey, value) => {
        const scpConfigObject = scpConfiguration && scpConfiguration.response && scpConfiguration.response.data && scpConfiguration.response.data[0];
        let configValueObject;
        if (scpConfigObject) {
            configValueObject = scpConfigObject[configkey].find((config) => config[valueKey] === value);
        }
        return configValueObject;
    };

    const getEMVObject = (valueKey, value) => {
        const emvConfigs = emvProfileCodes && emvProfileCodes.response && emvProfileCodes.response.data;
        let emvObject;
        if (emvConfigs && emvConfigs.length) {
            emvObject = emvConfigs.find((config) => config[valueKey] === value);
        }
        return emvObject;
    };

    const getPersoFormatCode = (valueKey, value) => {
        const persoFormats = persoFormatCodes && persoFormatCodes.response && persoFormatCodes.response.data;
        let personFormatObject;
        if (persoFormats && persoFormats.length) {
            personFormatObject = persoFormats.find((config) => config[valueKey] === value);
        }
        return personFormatObject;
    };

    const createFormData = (config) => {
        let configData = {};
        const hasConfig = match.params.id && config && config.response && config.response.data && config.response.data.length;
        const configObj = hasConfig ? config.response.data[0] : null;

        configData["defaultPinValue"] = "0000";

        if (configObj) {
            if (!match.params.id && !match.params.issuerCode) {
               

                configData = {
                    ...configData,
                    scpIssuers: scpIssuers && scpIssuers.length ? scpIssuers.find((issuer) => issuer.issuerCode === configObj.issuerCode) : null,
                    name: configObj.name,
                    autoUploadPerso: configObj.autoUploadPerso,
                    cardProfileCode: getSCPObject("cardProfiles", "name", configObj.cardProfileCode),
                    cardProgram: getSCPObject("cardPrograms", "name", configObj.cardProgram),
                    cardScheme: {
                        label: configObj.cardScheme,
                        value: configObj.cardScheme,
                    },
                    emvProfileCode: getEMVObject("name", configObj.emvProfileCode),
                    persoCode: getSCPObject("persos", "persoCode", configObj.persoCode),
                    persoFormatCode: getPersoFormatCode("name", configObj.persoFormatCode),
                    pinGenerationMethod: { name: configObj.pinGenerationMethod },
                    requestType: { type: configObj.requestType },
                    scpCardProgram: getSCPObject("scpCardPrograms", "name", configObj.scpCardProgram),
                    defaultPinValue: configObj.defaultPinValue,
                };
            }
        }

        return configData;
    };

    function fetchConfig() {
        dispatch(viewIssuerConfig(match.params.id));
    }

    const createConfiguration = (values) => {
        //
        //config && config.response && config.response.data && config.response.data[0].cardProfileCode
        if (match.params.id && match.params.issuerCode) {
            let formatData = {
                name: values && values.name ? values.name : "",
                description: values && values.description ? values.description : "",
                pinGenerationMethod: values && values.pinGenerationMethod ? values.pinGenerationMethod.value : " ",
                cardProfileCode: values && values.cardProfileCode ? values.cardProfileCode : "",
                cardProgram: values && values.cardProgram ? values.cardProgram : "",
                cardScheme: values && values.cardScheme ? values.cardScheme : "",
                emvProfileCode: values && values.emvProfileCode ? values.emvProfileCode : "",
                persoCode: values && values.persoCode ? values.persoCode : "",
                persoFormatCode: values && values.persoFormatCode ? values.persoFormatCode : "",
                batchId: config && config.response && config.response.data && config.response.data[0].id ? config.response.data[0].id.toString() : null,

                encryptJob: config && config.response && config.response.data && config.response.data[0].encryptJob ? true : false,
                defaultPinValue: values && values.defaultPinValue ? values.defaultPinValue : "0000",
            };

            dispatch(createIssuerConfig(formatData, match.params.id, issuerCode, history));
        } else {
            dispatch(createIssuerConfig(values, match.params.id, issuerCode));
        }
    };

    useEffect(() => {
        if (match.params.id && match.params.issuerCode) {
            dispatch(viewIssuerConfig(match.params.id, match.params.issuerCode));
        }
    }, [dispatch, match.params.id, match.params.issuerCode]);

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title">{match.params.id ? "Edit" : "Add"} Configuration</h3>
                </Col>
            </Row>
            <Row>
                <ConfigurationForm configId={match.params.id} config={config} onSubmit={createConfiguration} initialValues={createFormData(config)} fetchData={fetchConfig} />
            </Row>
        </Container>
    );
};

export default connect((state) => ({
    config: state.getIssuerConfig,
    scpConfiguration: state.getAllScpIssuerConfig,
    emvProfileCodes: state.getAllScpEmvProfileCode,
    scpIssuers: (state.scpIssuers && state.scpIssuers.response && state.scpIssuers.response.data) || [],
    persoFormatCodes: state.getAllPersoFormatCode,
    issuerCode: state.getIssuerDomainMapping && state.getIssuerDomainMapping.response && state.getIssuerDomainMapping.response.data ? state.getIssuerDomainMapping.response.data[0] : [],
}))(withRouter(IssuerConfigForm));
